import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const thresholdValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const lowerLimit = control.get('lowerLimit');
  const upperLimit = control.get('upperLimit');

  return lowerLimit && upperLimit && (+lowerLimit?.value > +upperLimit?.value) ? { lowerLimit: true } : null;
};
